class VariantRadios extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);    
  }
  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    if (!this.currentVariant){
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    }else {
      this.updateMedia();
      this.updateVariantInput();
      this.updateURL();
      this.renderProductInfo();
    }
  }
  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }
  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    var fetured_id = this.currentVariant.featured_media.id;
    if(document.querySelector('.media-thumb')){
      /*document.querySelectorAll('.media-thumb .media-grid-column').forEach(function(e){
        var mediaid = e.dataset.id;
        if(mediaid==fetured_id){
          new Swiper('.media-nav').slideTo(e.dataset.index,1000,false);
        }
      });*/
    }
  }
  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }
  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }
  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('.option-wrap'));
    const fieldlen = fieldsets.length;
    let option_count = 0;
    fieldsets.forEach(function(eachfield){
      var checked_gender = eachfield.querySelector('input:checked');
      if(checked_gender){
        option_count++;
      }
    });
    this.options = fieldsets.map((fieldset) => {
      if(option_count>=fieldlen){
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      }
    });
    if(option_count>=fieldlen){
      document.querySelector('.choose-cart').classList.remove('hide-selectore-button');
      document.querySelector('.choose-selector').classList.add('hide-selectore-button');      
    }else{
      document.querySelector('.choose-cart').classList.add('hide-selectore-button');
      document.querySelector('.choose-selector').classList.remove('hide-selectore-button');
    }   
  }
  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
    .then((response) => response.text())
    .then((responseText) => {
      const id = `price-${this.dataset.section}`;
      const html = new DOMParser().parseFromString(responseText, 'text/html')
      const destination = document.getElementById(id);
      const source = html.getElementById(id);
      if (source && destination) destination.innerHTML = source.innerHTML;
      if(this.currentVariant){
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      }
    });
  }
  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;
    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }
    if (!modifyClass) return;
  }
  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
  }
  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}
customElements.define('variant-radios', VariantRadios);
document.querySelector('.product-addcart').addEventListener('click',function(evt){
  evt.preventDefault();
  const config = fetchConfig('javascript');
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete config.headers['Content-Type'];
  var cartform = document.querySelector('.product-addcart').closest('form');
  const formData = new FormData(cartform);  
  config.body = formData;
  fetch(`${routes.cart_add_url}`, config)
  .then((response) => response.json())
  .then((response) => {
    if (response.status) {
      document.querySelector('.product-form-error').innerHTML = response.description;
      setTimeout(function(e){
        document.querySelector('.product-form-error').innerHTML  = '';
      },2000);
      return;
    }else{
      if(typeof load_cart == 'function'){
        load_cart();
        if($(window).width() > 991){
          setTimeout(function(e){
            document.querySelector('body').classList.add('open-drawer');
          },500);
        }
      }else{
        window.location.href = "/cart";
      }
      $('.snippet-addto-cart').addClass('successcart');
      setTimeout(function () {
        $('.snippet-addto-cart').removeClass('successcart');
      }, 3000);
    }
  })
  .catch((e) => {
    console.error(e);
  })
  .finally(() => {

  });
});
function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}
function getElementY(query) {
  return window.pageYOffset + document.querySelector(query).getBoundingClientRect().top
}
function doScrolling(element, duration) {
	var startingY = window.pageYOffset
  var elementY = getElementY(element)
  var targetY = document.body.scrollHeight - elementY < window.innerHeight ? document.body.scrollHeight - window.innerHeight : elementY
	var diff = targetY - startingY
  var easing = function (t) { return t<.5 ? 4*t*t*t : (t-1)*(2*t-2)*(2*t-2)+1 }
  var start
  if (!diff) return
	window.requestAnimationFrame(function step(timestamp) {
    if (!start) start = timestamp
    var time = timestamp - start
    var percent = Math.min(time / duration, 1)
    percent = easing(percent)
    window.scrollTo(0, startingY + diff * percent)
    if (time < duration) {
      window.requestAnimationFrame(step)
    }
  })
}
if(document.querySelector('.choose-selector')){
  if (window.innerWidth < 641) {
    document.querySelector('.choose-selector a').addEventListener('click', doScrolling.bind(null, '#product-form-installment', 2000))
  }
}
$(document).on('click','.pro-tab-top li a',function (e) {
  e.preventDefault();
  $(this).addClass('active').parent('li').siblings('li').find('a').removeClass('active');
  var datatitle = $(this).data('title');
  $('.pro-tab-content[data-title="'+datatitle+'"]').addClass('active').siblings().removeClass('active');
});
$(document).on('click','.mob-pro-tab',function name(e) {
  e.preventDefault();
  $(this).next('.pro-tab-contentinr').slideToggle();
  $(this).toggleClass('active');
});
$(".snippet-product-media-grid").flickity({
  pageDots: false,
  cellAlign: "left",
  contain: true,
  imagesLoaded: true,
  wrapAround: true,
  autoPlay: 3000,
  fade: true,
});
$(".pdp-media-thumbs").each(function () {
  var $thumbsWrap = $(this);
  var $mediaSlider = $(".snippet-product-media-grid");
  var $thumbs = $thumbsWrap.find(".pdp-media-thumb");
  $thumbsWrap.on("click", ".pdp-media-thumb", function () {
    $mediaSlider.flickity("select", $thumbs.index(this));
  });
  $mediaSlider.on("select.flickity", function (event, index) {
    var $active = $thumbs.removeClass("is-nav-selected").eq(index).addClass("is-nav-selected");
    if ($active.length) {
      $active[0].scrollIntoView({ behavior: "smooth", block: "nearest", inline: "nearest" });
    }
  });
});
/*$(".pdp-product-color-selector li a").hover(function(){
  $('.color-label').html($(this).data('color'));
  }, function(){
});*/
$(function() {
  var totalheight = $('.snippet-addto-cart').offset().top;
  var widnowheight = $(window).height();
  var otherTop = $(".footer-main").offset().top;
 
  $(window).scroll(function() {        
    var cartheight = totalheight - widnowheight;    
    var scroll = $(window).scrollTop();
    if (scroll >= totalheight) {
      $('body').addClass('stickybar');
    } else{
      $('body').removeClass('stickybar');
    }
    if((scroll >= otherTop)){
      $('body').removeClass('stickybar');

    }
  });
});
$(document).on('click','.pdp_sticky_top ',function (e) {
  e.preventDefault();
  if (window.innerWidth < 550) {
    $('html, body').animate({ scrollTop: 500 }, 1200);
  }else{
    $('html, body').animate({ scrollTop: 100 }, 1200);
  }
});